module.exports = __webpack_public_path__ + "img/hero-right.6e824ef7.png";